import { diffDay2, setTime } from '../../../../../../Utils/dateUtils';
import {
  tryStrToDate,
  tryStrToTime,
  dateTimeToStr,
  tryStrToDateTime,
  timeToStr,
} from '../../../../../../Utils/stringUtils';
import { getOneDayNameText } from '../../../../../../Utils/dayNames';

export const AktivitetDateTimeFormatter = (
  dateFrom: string,
  dateTill: string,
  timeFrom: string | null | undefined,
  timeTill: string | null | undefined
): string | null => {
  const fromDate = tryStrToDate(dateFrom);
  const dayNames = [
    'söndag',
    'måndag',
    'tisdag',
    'onsdag',
    'torsdag',
    'fredag',
    'lördag',
  ];
  const monthNames = [
    'januari',
    'februari',
    'mars',
    'april',
    'maj',
    'juni',
    'juli',
    'augusti',
    'september',
    'oktober',
    'november',
    'december',
  ];

  // ↓↓ check if the day is a holiday ↓↓
  let dayName = fromDate && getOneDayNameText(fromDate);
  if (!dayName) {
    dayName = fromDate && dayNames[fromDate.getDay()];
  }
  const monthName = fromDate && monthNames[fromDate.getMonth()];
  const dayNumber = fromDate && fromDate.getDate();
  const year = fromDate && fromDate.getFullYear();

  const formattedDate = `${dayName} ${dayNumber} ${monthName} ${year}`;
  const capitalizedDate =
    formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
  if (dateFrom !== dateTill) {
    const tillDate = tryStrToDate(dateTill);
    let endDayName = tillDate && getOneDayNameText(tillDate);
    if (!endDayName) {
      endDayName = tillDate && dayNames[tillDate.getDay()];
    }

    const endMonthName = tillDate && monthNames[tillDate.getMonth()];
    const endDayNumber = tillDate && tillDate.getDate();
    const endYear = tillDate && tillDate.getFullYear();
    const formattedEndDate = `${endDayName} ${endDayNumber} ${endMonthName} ${endYear}`;
    const capitalizedEndDate =
      formattedEndDate.charAt(0).toUpperCase() + formattedEndDate.slice(1);
    return `${capitalizedDate}, kl ${timeFrom} - ${capitalizedEndDate}, kl ${timeTill}`;
  }
  return `${capitalizedDate} kl ${timeFrom}-${timeTill}`;
};

export const combineDateAndTime = (date: string, time: string) => {
  const d = tryStrToDate(date);
  const t = tryStrToTime(time);
  return d && t ? dateTimeToStr(setTime(d, t)) : '';
};

export const formatDateAndTimeInterval = (
  dateAndTime1: string,
  dateAndTime2: string
) => {
  const dt1 = tryStrToDateTime(dateAndTime1);
  const dt2 = tryStrToDateTime(dateAndTime2);
  return dt1 && dt2
    ? `${dateTimeToStr(dt1)} - ${
        diffDay2(dt1, dt2) === 0 ? timeToStr(dt2) : dateTimeToStr(dt2)
      }`
    : '';
};
